export default "__VITE_ASSET__fe00a3a8__"